import { TGeneric } from '@/types/translations/types';

export default function translationfallbackTyped<T = string>(
  translationName: T,
  tFunction: TGeneric<T>,
  fallback: string
) {
  const translation = tFunction(translationName);
  if (!translation) {
    return fallback;
  }
  return translation === translationName ? fallback : translation;
}
